<template>
  <Modal
    v-model="_value"
    width="600"
    title="添加技术协助"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="technicalAssistance" :label-width="80" >
      <Row>
        <Col span="12">
      <FormItem prop="vehicleInfoId" label="问题车辆">
        <Select placeholder="请选择车辆"
                v-model="technicalAssistance.vehicleInfoId"
                filterable
                remote
                :remote-method="searchVehicleInfo"
                :loading="searchVehicleInfoLoading"
                class="field"
                @on-select="onselect"
                clearable>
          <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="option.id">{{option.registrationNum==null?option.vin:option.registrationNum}}</Option>
        </Select>
      </FormItem>
        </Col>
        <Col span="12">
      <FormItem prop="positioningDeviceInfo" label="问题设备">
        <Select v-model="technicalAssistance.positioningDeviceInfo">
          <Option v-for="item in positioningDeviceInfosTypeOptions" :value="item" :key="item.terminalNum">
            {{item.terminalNum + '(' + item.positioningDeviceModel.name + ')'}}
          </Option>
        </Select>
      </FormItem>
        </Col>
      </Row>
      <Row>
<!--        <Col span="12">-->
<!--          <FormItem prop="businessUserId" label="是否已收款">-->
<!--            <RadioGroup v-model="technicalAssistance.receptDatetime">-->
<!--              <Radio label="是"></Radio>-->
<!--              <Radio label="否"></Radio>-->
<!--            </RadioGroup>-->
<!--          </FormItem>-->
<!--        </Col>-->
        <Col span="12">
          <FormItem prop="qghyptOption" label="是否加急">
            <Space direction="vertical" size="large">
              <RadioGroup v-model="technicalAssistance.urgent">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </Space>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
      <FormItem prop="question" label="问题描述">
        <Input class="field" v-model="technicalAssistance.question" type="textarea">
        </Input>
      </FormItem>
        </Col>
      </Row>
        <Row>
          <Col span="24">
      <FormItem prop="remark" label="备注">
          <Input class="field" v-model="technicalAssistance.remark" type="textarea">
          </Input>
      </FormItem>
          </Col>
        </Row>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addtechnicalassistancemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      searchVehicleInfoLoading: false,
      searchVehicleInfoList: [],

      technicalAssistance: {
        businessUserId: null,
        businessUser: null,
        createUserId: null,
        createUser: null,
        vehicleInfoId: null,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        positioningDeviceInfoId: null,
        positioningDeviceInfo: {
          id: null,
          terminalNum: null,
          factoryTerminalNum: null,
          positioningDeviceModel: null,
          positioningDeviceModelId: null,
          sourceType: null,
          remark: null,
          setupDatetime: null,
          serviceDatetime: null
        },
        updateDatetime: null,
        assistanceDatetime: null,
        question: null,
        result: null,
        remark: null,
        urgent: '否',
        receptDatetime: '否'
      },

      positioningDeviceInfosTypeOptions: []

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    searchVehicleInfo (input) {
      this.searchVehicleInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoList = []
        this.searchVehicleInfoLoading = false
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoList = []
          store.getters.get_VehicleInfo_SearchByNameResult.forEach(item => {
            this.searchVehicleInfoList.push(item)
          })
          this.searchVehicleInfoLoading = false
        }).catch(err => {
          this.searchVehicleInfoLoading = false
        })
      }
    },
    /**
     * 选择车辆
     */
    onselect (e) {
      console.log(e)
      store.dispatch('VehicleInfoServ_GetDetail', {
        params: { id: e.value },
        urlparams: null
      }).then(res => {
        console.log(res)
        this.positioningDeviceInfosTypeOptions = store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos
      }).catch(err => {
        console.log(err)
      })
    },
    onOk () {
      if (this.technicalAssistance.receptDatetime == '是') {
        this.technicalAssistance.receptDatetime = new Date()
      } else {
        this.technicalAssistance.receptDatetime = null
      }
      if (this.technicalAssistance.urgent == '是') {
        this.technicalAssistance.urgent = true
      } else {
        this.technicalAssistance.urgent = false
      }
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认添加技术协助</p>',
        onOk: () => {
          // console.log(this.technicalAssistance)

          store.dispatch('TechnicalAssistanceServ_AddObj', { params: this.technicalAssistance }).then(() => {
            this.$Message.success('添加技术协助成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        if (this._initValue != null) {
          this.searchVehicleInfo(this._initValue)
        }
        this.technicalAssistance.vehicleInfoId = null
        this.technicalAssistance.bookingDatetime = null
        this.technicalAssistance.maintainType = 0
        this.technicalAssistance.question = null
        this.technicalAssistance.remark = null
        this.positioningDeviceInfosTypeOptions = []
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
